export const TRANSLATIONS_NL = {
    "accessibility_button": "Toegankelijkheid",
    "sidebar_Hotel": "Hotel",
    "sidebar_Rooms": "Kamers",
    "sidebar_verified": "Geverifieerd door Handiscover",
    "hotel_floors": "Verdiepingen",
    "hotel_totalRooms": "Totaal aantal kamers",
    "hotel_accessibleRooms": "Toegankelijke kamers",
    "hotel_allergyRooms": "Allergievriendelijke kamers",
    "mainContainer_accessibilityInformation": "Toegankelijkheidsinformatie",
    "mainContainer_pictures": "Afbeeldingen",
    "mainContainer_informationByDisability": "Informatie per beperking",
    "mainContainer_GeneralHotelInformation": "Algemene hotelinformatie",
    "informationByDisability_mobility": "Mobiliteit",
    "informationByDisability_hearing": "Gehoor",
    "informationByDisability_vision": "Zicht",
    "informationByDisability_other": "Overig",
    "rooms_header": "Kamerinformatie",
    "accessibility_room_icons": "Toegankelijkheidspictogrammen voor kamer",
    "roomInformation_generalRoomInformation": "Algemene kamerinformatie",
    "shopping_mall_mallFloors": "Verdiepingen van winkelcentrum",
    "shopping_mall_totalShops": "Geïnventariseerde winkels",
    "shopping_mall_accessibleParking": "Toegankelijke parkeerplaatsen",
    "shopping_mall_foodCourts": "Foodcourts",
    "mainContainer_GeneralMallInformation": "Algemene informatie winkelcentrum",
    "rooms_noPictures": "Deze kamer heeft geen afbeeldingen",
    "rooms_noInformation": "Er is geen informatie over deze kamer",
    "rooms_noIcons": "Geen toegankelijkheidspictogrammen",
    "property_noPictures": "Geen afbeeldingen gevonden voor deze locatie",
    "disability_noPictures": "Geen afbeeldingen voor de geselecteerde beperking",
    "accessibilityIcons_notPresent": "Geen toegankelijkheidspictogrammen",
    "shopping_mall": "Winkelcentrum",
    "building_area_buildings": "Gebouwen",
    "building_area_shops": "Geïnventariseerde winkels",
    "building_area_parking_spaces": "Toegankelijke parkeerplaatsen",
    "building_area_food_courts": "Foodcourts",
    "mainContainer_generalInformation": "Algemene informatie",
    "mainContainer_GeneralOfficeInformation": "Algemene kantoorinformatie",
    "mainContainer_GeneralShopInformation": "Algemene winkelinformatie",
    "header_buildingInformation": "Gebouwinformatie",
    "a11yStandard_shopping_mall": "Winkel",
    "a11yStandard_shopping_mall_plural": "Winkels",
    "property_floorSignular": "Verdieping",
    "property_floorPlural": "Verdiepingen",
    "property_tabTitle_shops": "Winkelinformatie",
    "general_invalid_API_CALL_errorMessage": "Er is een probleem opgetreden! Kon geen gegevens ophalen.",
    "general_missingInfo_forItem": "Het lijkt erop dat deze informatie nog niet is toegevoegd",
    "translated_text": "De titel is vertaald",
    "accessibility_button_open_ariaLabel": "Toegankelijkheidsinformatie openen",
    "mainContainer_mapView": "Kaartweergave",
    "mainContainer_generalAccessibility": "Algemene toegankelijkheid",
    "mapView_filterBy": "Filteren op",
    "mapView_filter_all": "Alles",
    "mapView_filter_entrance": "Ingang",
    "mapView_filter_parking": "Parkeren",
    "mapView_filter_toilet": "Toilet",
    "mapView_floor": "Verdieping",
    "selectDisabilityType_mobility": "Mobiliteit",
    "selectDisabilityType_hearing": "Gehoor",
    "selectDisabilityType_allergy": "Allergie",
    "selectDisabilityType_cognitive": "Cognitief",
    "selectDisabilityType_other": "Overig",
    "selectDisabilityType_select": "Selecteren",
    "selectDisabilityType_disability_type": "type beperking",
    "selectDisabilityType_select_disability_type": "Selecteer type beperking",
    "selectDisabilityType_select_what_type": "Filter op beperking",
    "selectDisabilityType_visual": "Visueel",
    "go_back": "Terug",
    "tabTitle_meetingRooms": "Vergaderruimtes",
    "tabTitle_hospitalityRooms": "Gastenkamers",
    "generalAccessibility_noGeneralAccessibilitiesForThisProperty": "Geen algemene toegankelijkheidsinformatie gevonden voor deze locatie",
    "generalAccessibility_noGeneralAccessibilitiesForTheseDisabilityFilters": "Geen algemene toegankelijkheidsinformatie gevonden voor deze filters",
    "informationByDisabilityContainer_noDataIsFound": "Geen gegevens gevonden",
    "informationByDisabilityContainer_weDoNotHaveTheData": "We hebben nog geen gegevens voor deze locatie",
    "informationByDisabilityContainer_tryAnotherDisabilityFiltering": "Probeer een andere filter voor beperkingen",
    "playground_information": "Speelplaatsinformatie",
    "total_playgrounds": "Totaal aantal speelplaatsen",
    "inventoried_playgrounds": "Geïnventariseerde speelplaatsen",
    "general_accessibility_and_information": "Algemene toegankelijkheid en informatie",
    "detailed_accessibility": "Gedetailleerde toegankelijkheid",
    "helsingborg_city_has_reviewed": "De stad Helsingborg heeft de toegankelijkheid van 26 van haar 200 speelplaatsen beoordeeld. Daar vindt u informatie over parkeren, toiletten en verschillende speelzones.",
    "for_detailed_accessibility_information": "Kies een speelplaats voor gedetailleerde toegankelijkheidsinformatie",
    "amount_of_accessible_toilets": "Aantal toegankelijke toiletten",
    "mapView_filter_elevator": "Lift",
    "mapView_filter_reception_infodesk": "Receptie",
    "mapView_filter_playground": "Speelplaats",
    "mapView_filter_garden": "Tuin",
    "mapView_filter_shop": "Winkel",
    "mapView_filter_restaurant": "Restaurant",
    "mapView_filter_conference_room": "Vergaderruimte",
    "mapView_filter_auditorium": "Auditorium",
    "jarfalla_municipality_has_reviewed": "De gemeente Järfälla heeft de toegankelijkheid van 55 speelplaatsen beoordeeld, waaronder 2 avontuurlijke speelplaatsen die creativiteit stimuleren.",
    "mapView_filter_vac": "Niveauverschil",
    "languages": "Talen",
    "english": "Engels",
    "swedish": "Zweeds",
    "danish": "Deens",
    "german": "Duits",
    "spanish": "Spaans",
    "french": "Frans",
    "norwegian": "Noors",
    "portuguese": "Portugees",
    "ukrainian": "Oekraïens",
    "dutch": "Nederlands",
    "accessibility_room": "Toegankelijke kamer",
    "pool": "Zwembad",
    "spa": "Spa",
    "bar_restaurant": "Bar/Restaurant",
    "bathrooms": "Badkamers",
    "shop": "Winkel",
    "exhibition": "Tentoonstelling",
    "rate_your_experience": "Kunt u ons helpen verbeteren 🧑‍🦼🦮🦻? 🙏",
    "did_you_find_the_accessibility_information_you_needed": "Heeft u de toegankelijkheidsinformatie gevonden die u nodig had?",
    "how_satisfied_are_you_with_your_experience": "Hoe tevreden bent u over uw ervaring met onze toegankelijkheidswidget?",
    "what_do_you_like_the_most": "Wat vindt u het leukst?",
    "sorry_to_hear_that": "Jammer om te horen! Geef alstublieft een toelichting bij uw beoordeling",
    "we_would_love_to_hear_your_suggestions": "We horen graag uw suggesties",
    "submit": "Verzenden",
    "book_now": "Nu boeken",
    "very_bad": "Zeer slecht",
    "bad": "Slecht",
    "neutral": "Neutraal",
    "good": "Goed",
    "great": "Geweldig",
    "common_buildings": "Algemene gebouwen",
    "hotels": "Hotels",
    "venues": "Locaties",
    "cottages": "Vakantiehuizen",
    "camping": "Camping",
    "restaurant": "Restaurant",
    "attractions": "Attracties",
    "amount_of_attractions": "Aantal attracties",
    "amount_of_toilets": "Aantal toiletten",
    "kiosk": "Kiosk",
    "close_ariaLabel": "Sluiten",
    "previous_picture_ariaLabel": "Vorige afbeelding",
    "next_picture_ariaLabel": "Volgende afbeelding",
    "cookieBanner_text": "We gebruiken cookies om uw ervaring op onze website te verbeteren. Door deze site te blijven gebruiken, stemt u in met het gebruik van cookies.",
    "cookieBanner_readMore": "Meer informatie",
    "cookieBanner_accept": "Accepteren",
    "cookieBanner_decline": "Weigeren"
}